import { createAction } from 'redux-actions';

import types from './types';

const setPeeriusData = createAction(types.SET_PEERIUS_DATA);
const clearPeeriusData = createAction(types.CLEAR_PEERIUS_DATA);

const setRecommendationsByWidgets = createAction(types.SET_RECOMMENDATIONS_BY_WIDGETS);

const setSmartContent = createAction(types.SET_SMART_CONTENT);

const sendImpressions = createAction(types.SEND_IMPRESSIONS);

const sendClick = createAction(types.SEND_CLICK);
const sendContentClick = createAction(types.SEND_CONTENT_CLICK);

export default {
    setPeeriusData,
    clearPeeriusData,
    setRecommendationsByWidgets,
    setSmartContent,
    sendImpressions,
    sendClick,
    sendContentClick,
};
